//BASE CLASS IMPORTS / PLUGIN IN IMPORTS
import React from 'react';
import { render } from "react-dom";

import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";

//FOR WEB VITAL CHECKING
import reportWebVitals from './reportWebVitals';

//PAGES AND TEMPLATES
import Landingpage from "./pages/Landingpage.jsx";
import Inquiryboard from "./pages/Inquiryboard.jsx";

const rootElement = document.getElementById("root");
render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<Landingpage />} />
      <Route path="/inqboard" element={<Inquiryboard />} />
      <Route
        path="*"
        element={ <p>There's nothing here!</p>}
      />
    </Routes>
  </BrowserRouter>,
  rootElement
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();